import { render, staticRenderFns } from "./DRPPaymentCalculator.vue?vue&type=template&id=a4e790ac&"
import script from "./DRPPaymentCalculator.vue?vue&type=script&lang=ts&"
export * from "./DRPPaymentCalculator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports